export default function initFixedHeaderMenu($menu, $body) {
    const fixedHeadMenuHandler = function () {
        const classes = 'menu_fixed';
        const windowTop = $(window)
            .scrollTop() + 1;
        windowTop > 1
            ? $menu.addClass(classes)
            : $menu.removeClass(classes);
        windowTop > 1
            ? $body.css("padding-top","87px")
            : $body.css("padding-top","0px");
    };
    fixedHeadMenuHandler();
    $(window).scroll(fixedHeadMenuHandler);
}
